@if (show) {
<mat-form-field>
    <mat-label>Employee</mat-label>
    <input #input type="text" matInput [formControl]="employee" [matAutocomplete]="auto"
        (input)="filter()" (focus)="filter()">
    <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayWithFunc">
        @for (employee of filteredEmployees; track employee) {
        <mat-option [value]="employee">({{employee.id | number:'5.0-0' | removeCommas}}) {{employee.first_name}} {{employee.last_name}}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
}